import * as React from "react";
import classnames from "classnames";

const FontAwesome = require("react-fontawesome");
const styles = require("./styles.module.scss");

interface DropdownModalProps {
  children: { trigger: React.ReactNode; content: React.ReactNode };
  leanRight?: boolean;
  style?: any;
}

class DropdownModal extends React.Component<DropdownModalProps, any> {
  state = { visible: false };

  toggleVisible = () => {
    this.setState(prev => ({ visible: !prev.visible }));
  };

  render() {
    const { visible } = this.state;
    const {
      children: { trigger, content },
      leanRight,
      style,
    } = this.props;
    return (
      <>
        <span className={styles.dropdownModal} style={{ ...style }}>
          <span className={styles.trigger} onClick={this.toggleVisible}>
            {trigger}
          </span>
          {visible && (
            <>
              <div className={classnames(styles.modal, leanRight && styles.leanRight)}>
                <FontAwesome className={styles.caret} name="caret-up" />
                {content}
              </div>
            </>
          )}
        </span>
        {visible && <span className={styles.backdrop} onClick={this.toggleVisible} />}
      </>
    );
  }
}

export default DropdownModal;
